'use client'

import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "@/app/_partials/_sections/_hooks/useSection";
import { frontendImage, shortDescription, showDateTime } from "@/lib/helpers";
import Link from "next/link";
import useBlogs from "../_hooks/useBlogs";
import { BlogBannerSkeleton } from "../_skeleton/BlogBannerSkeleton";
import Image from "next/image";

export const BlogBanner = () => {
    const { blogs, loading: blogLoading } = useBlogs();
    const { loading, content } = useSection('blog');
    const { trans } = useUtility();

    if (blogLoading || loading) {
        return <BlogBannerSkeleton />;
    }

    return (
        <section className="blog-banner-section section-bg pb-60">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <ul className="breadcrumb-list">
                            <li className="breadcrumb-list__item"><Link href="/" className="breadcrumb-list__link">{trans('Home')}</Link></li>
                            <li className="breadcrumb-list__item"><i className="fa-solid fa-chevron-right"></i></li>
                            <li className="breadcrumb-list__item"><a className="breadcrumb-list__link">{trans('Company')}</a></li>
                            <li className="breadcrumb-list__item"><i className="fa-solid fa-chevron-right text--warning"></i></li>
                            <li className="breadcrumb-list__item"> <span className="breadcrumb-list__text">{trans('Blog Listing')}</span></li>
                        </ul>
                    </div>
                    <div className="col-12">
                        <div className="blog-banner">
                            <h2 className="blog-banner__title">{trans('Blog')}</h2>
                            <div className="blog-banner__thumb">
                                <Image
                                    src={frontendImage(content?.header_image, "blog")}
                                    alt="Banner"
                                    width={1116}       
                                    height={551}       
                                    layout="responsive" 
                                />
                            </div>
                            <div className="blog-banner-item-wrapper">
                                <div className="row gy-3 justify-content-center">
                                    {blogs?.slice(0, 3)?.map((blog) => (
                                        <div className="col-lg-4 col-sm-6" key={'blog-item' + blog?.id}>
                                            <div className="blog-banner-item">
                                                <span className="blog-banner-item__tag">{trans(blog?.data_values?.category)}</span>
                                                <h6 className="blog-banner-item__title">
                                                    {shortDescription(blog?.data_values?.title, 51)}
                                                </h6>
                                                <div className="blog-banner-item__meta">
                                                    <span className="blog-banner-item__meta-date">{showDateTime(blog?.created_at, 'MMMM d, YYYY')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}